import {FC, useContext, useState} from 'react';
import {Navigate} from 'react-router-dom';
import {useRecoilValue} from 'recoil';

import {Box, CircularProgress, Stack, Typography} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

import {AuthContext} from '../../providers/AuthContextProvider';
import {EventBusContext} from '../../providers/EventBus';

import {authState} from '../../store/auth/atoms';
import {AuthService} from '../../api/services/auth.service';

const LoginPage: FC = () => {
  const {loading, apiAccess} = useContext(AuthContext);
  const {bus} = useContext(EventBusContext);
  const {isLoggedIn, isFirstLogin} = useRecoilValue(authState);
  const [disableBtn, setDisableBtn] = useState(false);

  const handleLogin = async () => {
    try {
      // Gets authentication url from backend server
      setDisableBtn(true);
      const {
        data: {url},
      } = await AuthService.getAuthUrl();
      // Navigate to consent screen
      window.location.assign(url);
    } catch (err) {
      bus?.emit('error', [err]);
      setDisableBtn(false);
    }
  };

  if (!apiAccess?.loading && !apiAccess?.hasAccess) return <Navigate to="/" replace />;

  if (loading || isFirstLogin)
    return (
      <Box>
        <Stack minHeight="100vh" minWidth="100vw" direction="column" alignItems="center" justifyContent="center">
          <CircularProgress />
        </Stack>
      </Box>
    );

  return isLoggedIn && !loading ? (
    <Navigate to={sessionStorage.getItem('current') || '/'} replace />
  ) : (
    <Box>
      <Stack
        minHeight="100vh"
        minWidth="100vw"
        direction="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        spacing={4}
      >
        <Typography variant="h1" sx={{fontSize: {xs: '24px', sm: '32px', fontWeight: 600}}}>
          Сервис Трек
        </Typography>
        <LoadingButton loading={disableBtn} disabled={disableBtn} onClick={handleLogin} variant="contained">
          Войти
        </LoadingButton>
      </Stack>
    </Box>
  );
};

export default LoginPage;
